export macrosReducer = (state, action) ->
  state ||= {
    macros: [],
    current: null
  }

  state
